"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var launchLegacyInstallerBot = function launchLegacyInstallerBot() {
  var installerConfig = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  /* eslint-disable no-undef */
  window.onmessage = function (e) {
    if (e.data.type === 'RWC_GET_TOKEN') {
      // source of window.open
      e.source.postMessage(Object.assign(installerConfig, {
        type: 'RWC_SET_TOKEN'
      }), '*');
    }
  };

  var url = "\n      ".concat(installerConfig.rwcClientUrl, "/c/slack-getting-started-installer-bot/i.html\n  ");
  var title = installerConfig.title || 'RWC Installer Bot';
  var windowDimensions = {
    width: 800,
    height: 600
  };
  var y = window.outerHeight / 2 + window.screenY - windowDimensions.height / 2;
  var x = window.outerWidth / 2 + window.screenX - windowDimensions.width / 2;
  var params = "\n      toolbar=no,\n      location=no,\n      directories=no,\n      status=no,\n      menubar=no,\n      resizable=no,\n      copyhistory=no,\n      scrollbars=no,\n      width=".concat(windowDimensions.width, ",\n      height=").concat(windowDimensions.height, ",\n      top=").concat(y, ",\n      left=").concat(x, "\n  ");
  var newWindow = window.open(url, title, params);

  if (window.focus) {
    newWindow.focus();
  }
};

var launchInstallerBot = function launchInstallerBot() {
  var installerConfig = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  /* eslint-disable no-undef */
  window.onmessage = function (e) {
    if (e.data.type === "RWC_GET_TOKEN") {
      // source of window.open
      e.source.postMessage(Object.assign(installerConfig, {
        type: "RWC_SET_TOKEN"
      }), "*");
    }
  };

  var url = "\n      ".concat(installerConfig.rwcClientUrl, "/").concat(installerConfig.encodedAccountId, "/").concat(installerConfig.chatName, "\n  ");
  var title = installerConfig.title || "RWC Installer Bot";
  var windowDimensions = {
    width: 835,
    height: 600
  };
  var y = window.outerHeight / 2 + window.screenY - windowDimensions.height / 2;
  var x = window.outerWidth / 2 + window.screenX - windowDimensions.width / 2;
  var params = "\n      toolbar=no,\n      location=no,\n      directories=no,\n      status=no,\n      menubar=no,\n      resizable=no,\n      copyhistory=no,\n      scrollbars=no,\n      width=".concat(windowDimensions.width, ",\n      height=").concat(windowDimensions.height, ",\n      top=").concat(y, ",\n      left=").concat(x, "\n  ");
  var newWindow = window.open(url, title, params);

  if (window.focus) {
    newWindow.focus();
  }
};

var _default = {
  launchLegacyInstallerBot: launchLegacyInstallerBot,
  launchInstallerBot: launchInstallerBot
};
exports.default = _default;